import { render, staticRenderFns } from "./BankTransferPaymentDetailsCollapse.vue?vue&type=template&id=be90ae0e&scoped=true&"
import script from "./BankTransferPaymentDetailsCollapse.vue?vue&type=script&lang=js&"
export * from "./BankTransferPaymentDetailsCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferPaymentDetailsCollapse.vue?vue&type=style&index=0&id=be90ae0e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90ae0e",
  null
  
)

export default component.exports